/**
 * Organization trainees API – all endpoints used by organization trainee management pages.
 * Base path: /admin/trainees (organization trainees routes mounted in backend admin routes).
 */
import { GET, POST, PUT, DELETE, UPLOAD_FILE } from '../../apiController';

const TRAINEES = '/admin/trainees';

// Get trainee details with pagination, search, and status filter
export const getTraineeDetails = async ({ page, limit, status, search }) => {
  const params = new URLSearchParams();
  if (page !== undefined && page !== null) params.set('page', String(page));
  if (limit !== undefined && limit !== null) params.set('limit', String(limit));
  if (search !== undefined && search !== null && String(search).trim() !== '') {
    params.set('search', String(search).trim());
  }
  // NOTE: backend treats "status is present" as filter, so don't send null/undefined
  if (status !== undefined && status !== null) {
    params.set('status', String(status));
  }

  const qs = params.toString();
  return GET(TRAINEES + `/trainee_details${qs ? `?${qs}` : ''}`);
};

// Toggle trainee active/inactive status
export const activeInactiveTrainee = (user_id, status) => {
  return PUT(`/admin/users/toggle-user-status/${user_id}`, { status });
};

// Fetch individual trainee details for editing
export const fetchUserDetails = (user_id) => {
  return GET(TRAINEES + `/get_trainee_details/${user_id}`);
};

// Delete a trainee
export const deleteTrainee = async (user_id) => {
  return DELETE(`/admin/users/delete-user/${user_id}`);
};

// Edit trainee details
export const editTraineeDetails = (trainee_id, data) => {
  return UPLOAD_FILE(TRAINEES + `/edit_trainee_details/${trainee_id}`, data);
};

// Create new organization user (trainee)
export const createNewOrganisationUser = (data) => {
  return UPLOAD_FILE(TRAINEES + `/orgUser`, data);
};

// Bulk upload trainees from Excel file
export const BulkUploadUserDetails = (data) => {
  return POST(TRAINEES + `/user_bulk_upload`, data);
};

// New JSON-based bulk upload
export const bulkUploadUsersJSON = (data) => {
  return POST(TRAINEES + `/users/bulk-upload`, data);
};

// Bulk validate trainees before import
export const bulkValidateUsersJSON = (data) => {
  return POST(TRAINEES + `/users/bulk-validate`, data);
};

/** GET — all trainees with course, classroom, and certificate aggregates for org reports */
export const getTraineesAnalytics = () => {
  return GET(`${TRAINEES}/trainees_analytics`);
};

// Download sample Excel template
export const getSample = () => {
  return GET(TRAINEES + `/sample_download`, {
    responseType: "arraybuffer",
  });
};

// Get organization users (alternative endpoint)
export const createOrgUsers = (data) => {
  return GET(TRAINEES + `/orgUser`, data);
};
